import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Protected Route for Child pages
 * Ensures only logged-in children can access child routes
 */
function ChildProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [isChildAuthenticated, setIsChildAuthenticated] = useState(false);

  useEffect(() => {
    const checkChildAuth = () => {
      const childUser = localStorage.getItem('childUser');
      const childToken = localStorage.getItem('childToken');
      
      // Child is authenticated if both exist
      setIsChildAuthenticated(!!(childUser && childToken));
      setLoading(false);
    };

    checkChildAuth();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-100 via-pink-100 to-blue-100">
        <div className="text-xl text-slate-600">Loading...</div>
      </div>
    );
  }

  if (!isChildAuthenticated) {
    return <Navigate to="/child/login" replace />;
  }

  return children;
}

export default ChildProtectedRoute;
